import $ from 'jquery';
import '@accessible360/accessible-slick';

declare global {
	interface JQuery {
		slick(options?: any): JQuery;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const $carousel = $('.testimonialCarousel .testimonialCarousel__items');

	// Places the Arrows based on the Dots width
	// $carousel.on('init', function(event, slick) {
	// 	const $dots = $(this).find('.slick-dots');
	// 	if ($dots.length) {
	// 		const dotsWidth = $dots.outerWidth() || 0;
	// 		const offset = ((dotsWidth / 2) - 30);
	// 		const $prev = $(this).find('.slick-prev');
	// 		const $next = $(this).find('.slick-next');

	// 		if ($prev.length) {
	// 			$prev.css('transform', `translateX(-${offset}px)`);
	// 		}
			
	// 		if ($next.length) {
	// 			$next.css('transform', `translateX(${offset}px)`);
	// 		}
	// 	}
	// });

	$carousel.slick({
		adaptiveHeight: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 10000,
		centerMode: true,
		centerPadding: 0,
		cssEase: 'ease',
		dots: true,
		draggable: true,
		fade: true,
		infinite: true,
		pauseOnHover: true,
		slidesToShow: 1,
		variableWidth: false,
		slidesToScroll: 1,
		speed: 300,
		responsive: [

		]
	});
});